import { AxiosError } from 'axios'

import { api } from '~/utils/api'

import { PersonalTrainer } from '../admin/types'
import { updateSessionUser } from '../authentication/services'
import { PersonalTrainerUser } from '../authentication/types'
import { insertToast } from '../toasts/services'
import { PersonalTrainerSingUpDTO, UpdatePersonalTrainerDTO } from './schema'

export type LogoMetadata = {
  key: string
  signedUrl: string
  publicUrl: string
  expiresIn: number
  expiresAt: string
}

export type PersonalTrainerLogoResponse = {
  success: boolean
  logoUrl: string
  logo: LogoMetadata
  message: string
}

export async function getPersonalTrainerMe(signal?: AbortSignal) {
  return api
    .get<PersonalTrainerUser>('/personal-trainers/me', { signal })
    .then(({ data }) => data)
    .catch(() => undefined)
}

export async function updatePersonalTrainer(payload: UpdatePersonalTrainerDTO) {
  return api
    .patch<PersonalTrainer>('/personal-trainers', payload)
    .then(({ data }) => {
      updateSessionUser(data as unknown as PersonalTrainerUser)
      insertToast({
        duration: 3,
        message: 'Perfil atualizado',
        title: 'Sucesso!',
      })

      return true
    })
    .catch((error: AxiosError<APIError>) => {
      if (error.response?.data.message) {
        insertToast({
          duration: 3,
          message: error.response?.data.message,
          title: 'Erro ao atualizar perfil',
        })
      }

      return false
    })
}

export async function signUpPersonalTrainer(payload: PersonalTrainerSingUpDTO) {
  return api
    .post<PersonalTrainer>('/personal-trainers/signup', payload, {
      baseURL: import.meta.env.VITE_BASE_URL_API,
    })
    .then(({ data }) => {
      insertToast({
        title: 'Sucesso!',
        message: 'Cadastro concluído. Você pode acessar o GPA agora!',
        duration: 8,
        type: 'success',
      })

      return data
    })
    .catch((e: AxiosError<APIError>) => {
      if (e.response?.data.message) {
        insertToast({
          title: 'Erro ao Registrar',
          message: e.response?.data.message,
          duration: 3,
          type: 'error',
        })
      }
    })
}

export async function trialSignUpPersonalTrainer(
  payload: PersonalTrainerSingUpDTO,
) {
  return api
    .post<PersonalTrainer>('/personal-trainers/signup/trial', payload, {
      baseURL: import.meta.env.VITE_BASE_URL_API,
    })
    .then(({ data }) => {
      insertToast({
        title: 'Sucesso!',
        message: 'Cadastro concluído. Você pode acessar o GPA agora!',
        duration: 8,
        type: 'success',
      })

      return data
    })
    .catch((e: AxiosError<APIError>) => {
      if (e.response?.data.message) {
        insertToast({
          title: 'Erro ao Registrar',
          message: e.response?.data.message,
          duration: 3,
          type: 'error',
        })
      }
    })
}

export async function uploadPersonalTrainerLogo(file: File) {
  const formData = new FormData()
  formData.append('logo', file)

  return api
    .post<PersonalTrainerLogoResponse>('/personal-trainers/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(({ data }) => data)
    .catch((error: AxiosError<APIError>) => {
      throw error
    })
}

export async function fetchPersonalTrainerLogoUrl(signal?: AbortSignal) {
  return api
    .get<PersonalTrainerLogoResponse>('/personal-trainers/logo/url', {
      signal,
    })
    .then(({ data }) => data)
}
